import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-column footer-brand">
            <h3 className="footer-logo">VerTechnology</h3>
            <p className="footer-tagline">
              Technology That Works the Way Your Business Does
            </p>
            <p className="footer-description">
              Vendor-neutral, outcome-driven partner for your technology needs.
            </p>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">Services</h4>
            <ul className="footer-links">
              <li><a href="#technology">Business Technology Services</a></li>
              <li><a href="#software">Business Software Services</a></li>
              <li><a href="#intelligence">Business Intelligence Services</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">Company</h4>
            <ul className="footer-links">
              <li><a href="#about">About Us</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">Contact Us</h4>
            <ul className="footer-contact">
              <li>Phone: (208) 656-2655</li>
              <li>Email: info@vertechnology.com</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © 2025 Vertechnology. All rights reserved.
          </p>
          <div className="footer-legal">
            <a href="#privacy">Privacy</a>
            <a href="#terms">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
